module.exports = __webpack_public_path__ + "static/media/IS.4b879293.svg";